<template>
  <div class="acomodar">
    <div class="d-flex flex-wrap justify-content-start align-items-center gap-2 my-3 mx-2">


      <!-- <button class="btn btn-danger" @click="$router.push('/gestionSolicitudes')"> -->
     <button class="btn btn-danger" @click="$router.push('/gestionSolicitudes')">
        <i class="bi bi-skip-backward"></i>
      </button>


      <button class="btn btn-success" @click="base"
        v-if="permisoVisualizador == 2 || (permisoVisualizador == 18 && prender)" title="BASE DE DATOS POSTULANTES">
        <i class="bi bi-database-add"></i>
      </button>


      <button :disabled="botonCambioRq" class="btn btn-success" @click="editarDatoSolicitud" title="MODIFICAR SOLICITUD"
        v-if="(permisoVisualizador == 2 || permisoVisualizador == 10 || permisoVisualizador == 18) && prender">
        <i class="bi bi-pencil-square"></i>
      </button>

      <!-- Modal: Asignar Personal -->
      <b-button v-b-modal.modal-center class="btn btn-success" title="ASIGNAR PERSONAL DE SELECCION">
        <i class="bi bi-person-workspace"></i>
      </b-button>

      <b-modal id="modal-center" centered title="ASIGNAR PERSONAL DE SELECCION">
        <div class="d-flex flex-column flex-sm-row mt-2 gap-2">
          <select class="form-control" @change="ModificarTrabajador($event)">
            <option selected>--ESCOGER AL ENTREVISTADOR--</option>
            <option v-for="ide in responsable" :key="ide.id" :value="ide.idTrabajador">
              {{ ide.nombreTrabajador }}
            </option>
          </select>
          <button :disabled="negado2" class="btn btn-success" @click="getAttributesPut">
            <i class="bi bi-floppy"></i>
          </button>
        </div>
      </b-modal>

      <!-- Modal: Cambiar Estado -->
      <b-button v-b-modal.modal-center1 class="btn btn-success" title="CAMBIAR ESTADO DE SOLICITUD">
        <i class="bi bi-file-earmark-x"></i>
      </b-button>

      <b-modal id="modal-center1" centered title="CAMBIAR ESTADO DE SOLICITUD">
        <div class="d-flex flex-column flex-sm-row gap-2 mt-2">
          <select class="form-control" @change="ModificarEstado($event)">
          <option>--SELECCIONAR ESTADO--</option>
            <option v-for="estados in info.slice(2, 4)" :key="estados.id" :value="estados.parCorrelativo">
              {{ estados.parDescripcion }}
            </option>
          </select>
          <button class="btn btn-success" :disabled="negado" @click="getAttributesEstado">
            <i class="bi bi-floppy"></i>
          </button>
        </div>
      </b-modal>

      <!-- Botón PDF -->
      <button class="btn btn-success">
        <i class="bi bi-file-earmark-pdf"></i>
      </button>

      <!-- Etiquetas -->
      <div class="ms-auto text-end">
        <label v-if="campaña" class="text-danger fw-bold me-3 d-block d-sm-inline">
          <i class="bi bi-rocket-takeoff"></i> CAMPAÑA
        </label>
        <label class="ms-4 letrasTitulos" style="font-size: 1.73rem">N°</label>
        <label class="ms-1 me-4 letrasTitulos" disabled style="font-size: 1.73rem">{{ IdSolicitud }}</label>
      </div>
    </div>
    <div class="mx-2">
      <div class="col-12">
        <div class="border border-1 rounded-3 px-3 py-2 mb-2 bg-white shadow-sm 
              d-flex justify-content-between align-items-center flex-wrap">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-journal-text display-5 text-primary"></i>
            <div class="lh-sm">
              <p class="mb-1 reducirTamaño text-secondary fw-semibold text-uppercase">
                GESTION DE LA SOLICITUD
              </p>
              <p class="mb-0 tituloResaltado fs-5 fw-bold">DATOS DE LA SOLICITUD:</p>
            </div>
          </div>
          <div class="text-end my-auto">
            <i class="bi bi-chevron-down fs-5" @click="ocultar = !ocultar"></i>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div v-if="ocultar" class="tamaño row g-2 mb-2">
          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 letrasTitulos" style="font-size: 1.16rem">
              <label class="ms-2" disabled style="font-weight: 700">
                <strong>{{ CanPostulante }}</strong> {{ NomPuesto }}</label>
            </div>
          </div>

          <div class="col-12 col-md-5">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 letrasTitulos"
              style="font-size: 1.16rem; font-weight: 700">
              <label class="ms-2" disabled>
                {{ DesDepartamento }} - {{ DesProvincia }} -
                {{ DesDistrito }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 text-end">
              <label class="text-danger ms-1" style="font-weight: 800" :class="{
                'text-danger ': FecPresentacion.slice(7, 11) == '1900',
              }">DEADLINE:</label>
              <label style="font-weight: 800" v-if="
                FecPresentacion.slice(7, 11) != '1900'
                  ? (cerrarPostulante = true)
                  : (cerrarPostulante = false)
              " class="ms-1" disabled>
                {{ FecPresentacion.slice(0, 10) }}</label>

              <label style="font-weight: 800" :class="{ 'text-danger': FecPresentacion.slice(7, 11) == '1900' }"
                v-if="FecPresentacion.slice(7, 11) == '1900'" class="ms-1" disabled>
                -
              </label>

              <div class="text-dark">
                <label class="" disabled> {{ nomSelAsignado }}</label>
              </div>

              <div class="">
                <label style="font-weight: 800" class="text-primary" disabled>
                  {{ desSolEstado }}</label>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row g-2">

              <p class="mb-0 tamaño">
                REQUERIMIENTO SOLICITADO EL
                <label style="font-weight: 700">{{ FecRegistro }} </label>
                (LA FECHA ESTIMADA DE ENTREGA ES EL
                <label class="" style="font-weight: 700">{{ FecFinEstimada }}</label>)
              </p>


              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 ps-2 pintar">SERVICIO:</p>
                  <label class="tamaño ps-2" disabled>
                    {{
                      idEmpresaRq == 1
                        ? 'SELECCION'
                        : [2, 3].includes(idEmpresaRq)
                          ? 'OUTSOURCING'
                          : 'INTERMEDIACIÓN'
                    }}
                  </label>
                </div>
              </div>

              <div class="col-12 col-md-2">

                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 ps-2 pintar">PROYECTO:</p>
                  <label class="tamaño ps-2" disabled>
                    <!-- {{ NomEmpresa }} | {{ CentroCosto }} | -->
                    {{ SubCentroCosto }} |
                    {{ SubSubCentroCosto }}
                  </label>
                </div>
              </div>


              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">SOLICITANTE:</p>
                  <label class="" disabled> {{ NomTrabajador }}</label>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">MOTIVO:</p>
                  <p class="mb-0" disabled>{{ DesMotivo }}</p>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">LUGAR DE TRABAJO:</p>
                  <label class="" disabled> {{ LugarTrabajo }}</label>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0 pintar">HORARIO DE TRABAJO:</p>
                  <label class="" disabled> {{ HorTrabajo }}</label>
                </div>
              </div>

              <!-- <div class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
                  <p class="mb-0  pintar">TIPO DE CONTRATO:</p>
                  <label class="" disabled> {{ DesTipContrato }}</label>
                </div>
              </div> -->
              <div class="col-12">
                <div class="border rounded-3 px-3 py-2 bg-white shadow-sm">
                  <p class="mb-0 ms-2 pintar">DETALLE:</p>
                  <label class="ms-2" disabled> {{ DesExtra }}</label>
                </div>
              </div>


              <!-- ICONO -->
              <div class="col-12 " v-if="
                permisoVisualizador == 2 ||
                permisoVisualizador == 6 ||
                permisoVisualizador == 8 ||
                (permisoVisualizador == 18 && codigoCentro != '02')
              ">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm">
                  <div class="d-flex flex-wrap justify-content-around text-center">
                    <div class="mx-3">

                      <i class="bi bi-calendar3 fs-4"></i>
                      <p class="color mb-0">{{ DesOpoPago }}</p>
                      <p class="tamaño mb-0" disabled>Oportunidad de Pago</p>
                    </div>

                    <div v-if="SueldoMensual > 0" class="mx-3">
                      <i class="bi bi-cash-stack fs-4"></i>
                      <p class="color mb-0">{{ SueldoMensual }}</p>
                      <p class="mb-0 tamaño" disabled>Sueldo básico(RBM)</p>
                    </div>

                    <div v-if="SueldoDiario > 0" class="mx-3">
                      <i class="bi bi-coin fs-4"></i>
                      <p class="color mb-0">{{ SueldoDiario }}</p>
                      <p class="tamaño" disabled>Sueldo básico(RBD)</p>
                    </div>

                    <div v-if="MonAlimientacion > 0" class="mx-3">
                      <i class="bi bi-cup-hot fs-4"></i>
                      <p class="color mb-0">{{ MonAlimientacion }}</p>
                      <p class="tamaño" disabled>Alimentación</p>
                    </div>

                    <div v-if="MonMovilidad > 0" class="mx-3">
                      <i class="bi bi-car-front-fill fs-4"></i>
                      <p class="color mb-0">{{ MonMovilidad }}</p>
                      <p class="tamaño" disabled>Movilidad</p>
                    </div>

                    <div v-if="MonVariable > 0" class="mx-3">
                      <i class="bi bi-wallet2 fs-4"></i>
                      <p class="color mb-0">{{ MonVariable }}</p>
                      <p class="tamaño" disabled>Variable</p>
                    </div>

                    <div v-if="MonViatico > 0" class="mx-3">
                      <i class="bi bi-luggage fs-4"></i>

                      <p class="color mb-0">{{ MonViatico }}</p>
                      <p class="tamaño" disabled>Viáticos</p>
                    </div>

                    <div v-if="HoraExtra > 0" class="mx-3">
                      <i class="bi bi-hourglass-top fs-4"></i>
                      <p class="color mb-0">{{ HoraExtra }}</p>
                      <p class="tamaño" disabled>Hrs Extra</p>
                    </div>

                    <div v-if="DiasDescanso > 0" class="mx-3">
                      <i class="bi bi-calendar-event fs-4"></i>
                      <p class="color mb-0">{{ DiasDescanso }}</p>
                      <p class="tamaño" disabled>Descanso(Días)</p>
                    </div>

                    <div v-if="MonOtro > 0" class="mx-3">
                      <i class="bi bi-file-plus fs-4"></i>
                      <p class="color mb-0">{{ MonOtro }}</p>
                      <p class="tamaño" disabled>Otros</p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="
                IndVacuna ||
                IndCarnet ||
                IndVulnerabilidad ||
                indJudiciales ||
                indPoliciales ||
                indPenales ||
                indSanidad ||
                indCertijoven
              " class="col-12 col-md-3 tamaño">
               <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- ICONO IZQUIERDA -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-check fs-2 text-success"></i>
                  </div>
                <div class="flex-grow-1">
                    <div v-if="IndVacuna" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndVacuna" />
                      <label class="form-check-label">CARNET DE VACUNACION</label>
                    </div>

                    <div v-if="IndCarnet" class="form-check mb-0">
                      <input disabled class="form-check-input mb-0" type="checkbox" v-model="IndCarnet" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="IndVulnerabilidad" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="IndVulnerabilidad" />
                      <label class="form-check-label">DECLARACION JURADA DE VULNERABILIDAD</label>
                    </div>

                    <div v-if="indJudiciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indJudiciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES JUDICIALES</label>
                    </div>

                    <div v-if="indPoliciales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPoliciales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES POLICIALES</label>
                    </div>

                    <div v-if="indPenales" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indPenales" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES PENALES</label>
                    </div>

                    <div v-if="indSanidad" class="form-check mb-0">
                      <input disabled class="form-check-input" type="checkbox" v-model="indSanidad" />
                      <label class="form-check-label">CARNET DE SANIDAD</label>
                    </div>

                    <div v-if="indCertijoven" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" v-model="indCertijoven" />
                      <label class="form-check-label">CERTIFICADO DE ANTECEDENTES O CERTIJOVEN</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="IndEmpo || IndCovid" class="col-12 col-md-3 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <div class="mx-3 text-center my-auto">
                    <i class="bi bi-clipboard-heart fs-2 text-danger"></i>
                  </div>
                  <div class="">
                    <div v-if="IndEmpo" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndEmpo" />
                      <label class="form-check-label" for="flexCheckDefault">
                        EXAMEN MEDICO PRE-OCUPACIONAL(EMPO)
                      </label>
                    </div>
                    <div v-if="IndCovid" class="form-check">
                      <input disabled class="form-check-input" type="checkbox" value="" v-model="IndCovid" />
                      <label class="form-check-label" for="flexCheckDefault">
                        PRUEBA COVID
                      </label>
                    </div>
                  </div>
                </div>
              </div>

                <div class="col-lg-4 col-md-6 tamaño">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 d-flex">
                  <!-- Icono centrado -->
                  <div class="me-3 d-flex align-items-center">
                    <i class="bi bi-clipboard-data fs-2 text-primary"></i>
                  </div>
                  
                    <!-- Opciones compactas -->
                  <div class="d-flex flex-wrap flex-grow-1">
                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solDisViaje" />
                      <label class="form-check-label">DISPONIBILIDAD DE VIAJE</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovPropio" />
                      <label class="form-check-label">USO DE MOVIL PROPIO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solAplicativo" />
                      <label class="form-check-label">USO DE APLICATIVOS</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solEpps" />
                      <label class="form-check-label">USO DE EPPs</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solUniforme" />
                      <label class="form-check-label">USO DE UNIFORME</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solMovil" />
                      <label class="form-check-label">USO DE MOVIL CORPORATIVO</label>
                    </div>

                    <div class="col-6 d-flex align-items-center mb-1">
                      <input disabled class="form-check-input me-2" type="checkbox" v-model="solLaptop" />
                      <label class="form-check-label">USO DE LAPTOP CORPORATIVA</label>
                    </div>
                  </div>
                </div>
              </div>

             <div v-if="rutaPerfil != '0'" class="col-12 col-md-2">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
                  
                  <p class="mt-2 text-center mb-0 align-self-center">FORMATO DE PERFIL DEL PUESTO </p>
                  <a  :href="url.slice(0, 49) + rutaPerfil.slice(42)" target="_blank"> 
                    <button class="btn btn-primary text-white boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </button>
                  </a>
                  <!-- {{ rutaPerfil }} -->
                </div>
              </div>


              <div v-if="Adjunto != 1" class="col-12 col-md-4 ">
                <div class="border rounded-3 px-3 py-3 bg-white shadow-sm h-100 text-center">
                  <div class="my-auto text-center">
                    <a :href="url + Adjunto.slice(52, Adjunto.length)" target="_blank" class="align-self-center">
                      <i class="bi bi-file-earmark-arrow-down fs-2"></i>
                    </a>
                    <!-- <p class="text-center mb-0 align-self-center" v-if="Adjunto == 1">
                SIN ADJUNTO
              </p> -->
                    <p class="text-center mb-0 align-self-center">
                      {{ Adjunto.slice(52, Adjunto.length) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ss -->

    <!-- tabla -->
    <div class="mt-3">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-content-end align-items-center">
              <label class="mt-4 me-2"></label>

              <div class="input-group w-25 mt-3">
                <span class="input-group-text bg-white">
                  <i class="bi bi-search"></i>
                </span>
                <input type="text" class="form-control form-control-lg"
                  placeholder="Búsqueda por nombres y apellidos..." v-model="dni_busqueda" />
              </div>
            </div>

            <div class="mt-2 tamaño ms-2">
              (*) Solo escoger el estado de
              <strong class="text-success"> SELECCIONADO </strong> cuando estén
              terminadas todas las etapas de:<strong>
                Selección, Entrevista, Documentos y Capacitación.
              </strong>
            </div>
            <div class="table-responsive mt-2 mx-2">
              <div>
                <table class="table table-bordered tamañoLetra">
                  <thead>
                    <tr class="bg-solimano text-center tamañoLetra text-white">
                      <th colspan="4"></th>
                      <th colspan="2">SELECCION</th>
                      <th colspan="2">ENTREVISTA</th>
                      <th colspan="2">DOCUMENTO</th>
                      <th colspan="2">CAPACITACION</th>
                      <th colspan="2">CONTRATOS</th>

                      <th colspan="5"></th>
                    </tr>
                    <tr class="bg-solimano text-center text-white">
                      <th scope="col">ID</th>
                      <th scope="col">REF.</th>
                      <th scope="col">POSTULANTE</th>
                      <th scope="col">ESTADO</th>

                      <th selector scope="col">ETAPA</th>

                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>
                      <th scope="col">ETAPA</th>
                      <th scope="col">FECHA EJECUTADA</th>

                      <th scope="col">
                        <i class="bi bi-boxes fs-5"></i>
                      </th>
                      <th scope="col" v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        FEC.INIC.CONTRATO
                      </th>
                      <th scope="col" v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        FEC.FIN.CONTRATO
                      </th>
                      <!-- <th scope="col" v-if="permisoVisualizador == 6">ACCION</th> -->
                    </tr>
                  </thead>
                    <tbody class="text-nowrap text-center align-middle" v-for="(post, index) in paginatedInfo"
                    :key="post.idSolxPostulante">
                    <tr class="text-center">
                      <th class="">
                        <span class="">{{ post.idSolxPostulante }} </span>
                      </th>
                      <td class="text-center">
                        <!-- <button :disabled="permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                            ? false
                            : true
                          " class="btn py-1 my-0 border-0">
                          <i class="bi bi-star-fill" @click="cambiarReferido(post.idSolxPostulante)" :class="{
                            'text-warning ': post.solReferido,
                            'text-secondary ': !post.solReferido,
                          }"></i> -->
                        <div class="referido">
                          <select v-if="
                            permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                          " class="form-control text-secondary text-center tamaño w-100 py-1 my-0" @change="
                            cambiarReferido(
                              post.idSolxPostulante,
                              $event.target.value
                            )
                            ">
                            <option v-if="post.solfuente != null" selected disabled value="">
                              {{ post.solfuente }}
                            </option>

                            <option v-if="post.solfuente == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="referencia in referido" :key="referencia.idParametro"
                              :value="referencia.parCorrelativo">
                              <i class="bi bi-star-fill"></i>
                              {{ referencia.parDescripcion }}
                            </option>
                          </select>

                        </div>

                        <!-- </div> -->

                        <!-- 
                        </button> -->
                      </td>

                      <td class="text-start">
                        <span class="text-danger mx-2" v-if="
                          post.nombre.slice(0, 21) == '[FALTA CREAR USUARIO]'
                        ">
                          {{ post.nombre.slice(0, 21) }}
                        </span>
                        <span v-if="
                          post.nombre.slice(0, 21) == '[FALTA CREAR USUARIO]'
                        ">
                          {{ post.nombre.slice(21, post.nombre.length) }}
                        </span>
                        <span class="text-start" v-else>{{ post.nombre }}</span>
                      </td>

                      <td class="text-nowrap text-center align-middle">
                        <div class="agrandar d-flex">
                          <!-- {{ post.solDesMotivo }} -->
                            <div class="my-auto">
                              <select v-if="
                            permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                          " class="form-control text-secondary text-center tamaño w-100 py-1 my-0" @change="
                            comenta(
                              $event,
                              post.idSolxPostulante,
                              post.solPosMotivo,
                              post.solComentario
                            )
                            "
                            :disabled="post.solPosContratos"
                            >
                            <option v-if="post.solDesMotivo != null" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-show="coment.parCorrelativo !== '010' || (post.solPosSeleccion == 1 && post.solPosEntrevista == 1 && post.solPosDocumento == 1 && post.solPosCapacitacion == 1 )"  v-for="coment in comentarios.slice(0, 7)" :key="coment.id"
                              :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }} 
                            </option>
                          </select>

                          <select v-if="permisoVisualizador == 10"
                            class="form-control  tamaño text-center py-1 my-0 text-secondary" @change="
                              comenta(
                                $event,
                                post.idSolxPostulante,
                                post.solPosMotivo,
                                post.solComentario
                              )
                              "
                            :disabled="post.solPosMotivo === '010'"
                              >
                            <option v-if="post.solDesMotivo != ''" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="coment in comentarios.slice(7, 11)" :key="coment.id"
                              :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }}
                            </option>
                          </select>

                          <select v-if="permisoVisualizador == 9"
                            class="form-control tamaño py-1 my-0 text-center text-secondary" @change="
                              comenta(
                                $event,
                                post.idSolxPostulante,
                                post.solPosMotivo,
                                post.solComentario
                              )
                              "                          
                              :disabled="post.solPosMotivo === '010'"
                            >
                            <option v-if="post.solDesMotivo != ''" selected disabled value="">
                              {{ post.solDesMotivo }}
                            </option>

                            <option v-if="post.solDesMotivo == ''" selected disabled value="">
                              Selecciona Comentario...
                            </option>
                            <option v-for="coment in comentarios.slice(
                              11,
                              comentarios.length
                            )" :key="coment.id" :value="coment.parCorrelativo">
                              {{ coment.parDescripcion }}
                            </option>
                          </select>
                            </div>
                          
                            <div v-if="permisoVisualizador == 9">
                          <div class="ms-2 d-flex align-items-center">
                            <label 
                              :for="'file-' + post.idSolxPostulante" 
                              class="btn btn-outline-primary btn-sm py-1 px-2 mb-0"
                              title="Subir archivo"
                            >
                              <i class="bi bi-cloud-upload"></i>
                            </label>

                            <input 
                              :id="'file-' + post.idSolxPostulante" 
                              type="file" 
                              accept=".pdf" 
                              class="d-none" 
                              @change="handleFileUpload($event, post, index)"
                            />

                            <small v-if="post.fileName" class="ms-2 text-success fw-bold text-truncate" style="max-width: 100px; font-size: 10px;">
                              <i class="bi bi-check-all"></i> {{ post.fileName }}
                            </small>

                              <a 
                            v-if="post.estadoAdjuntoPresencial" 
                            :href="url2 + post.rutaDocumento.slice(46)" 
                            class="btn btn py-1 my-0 bg-danger text-white px-2 ms-1" 
                            target="_blank"
                            >
                            <i class="bi bi-cloud-download"></i>
                            </a>
                            <button 
                            v-else 
                            class="btn btn py-1 my-0 bg-light px-2 ms-1" 
                            disabled
                            >
                            <i class="bi bi-cloud-download"></i>
                            </button>
                          </div>
                          <!-- + post.rutaDocumento, -->
                          
                            </div>
                         

                       
                        </div>
                        <span v-if="
                          permisoVisualizador == 6 || permisoVisualizador == 4
                        " :class="{
                          'text-success': post.solPosMotivo == '010',
                          'text-danger':
                            post.solPosMotivo != '010' &&
                            post.solPosMotivo != '011',
                          'text-primary ': post.solPosMotivo == '011',
                          'text-primary ': post.solPosMotivo == '005',
                        }" class="tamaño">
                          {{ post.solDesMotivo }}</span>
                      </td>

                      <td>
                        <button @click="editSeleccion(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosSeleccion,
                          'btn btn-success py-1 my-0': post.solPosSeleccion,
                        }">
                          <i v-if="post.solPosSeleccion" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosSeleccion" class="bi bi-person-bounding-box"></i>
                        </button>
                      </td>

                      <td class="text-center" v-if="post.solFecSelEjec.slice(0, 4) == 1900">
                        --
                      </td>
                      <td v-else>{{ post.solFecSelEjec.slice(0, 10) }}</td>

                      <td>
                        <button @click="editEntrevista(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosEntrevista,
                          'btn btn-success py-1 my-0': post.solPosEntrevista,
                        }">
                          <i v-if="post.solPosEntrevista" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosEntrevista" class="bi bi-headset"></i>
                        </button>
                      </td>

                      <td class="text-center" v-if="post.solFecEntEjec.slice(0, 4) == 1900">
                        --
                      </td>

                      <td v-else>{{ post.solFecEntEjec.slice(0, 10) }}</td>

                      <td>
                        <button @click="editDocumentos(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosDocumento,
                          'btn btn-success py-1 my-0': post.solPosDocumento,
                        }">
                          <i v-if="post.solPosDocumento" class="bi bi-check-circle"></i>

                          <i v-if="!post.solPosDocumento" class="bi bi-folder2-open"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecDocEjec.slice(0, 4) == 1900">--</td>

                      <td v-else>{{ post.solFecDocEjec.slice(0, 10) }}</td>

                      

                     

                      <td>
                        <button @click="editCapacitaciones(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0':
                            !post.solPosCapacitacion,
                          'btn btn-success py-1 my-0':
                            post.solPosCapacitacion,
                        }">
                          <i v-if="post.solPosCapacitacion" class="bi bi-check-circle"></i>
                          <i v-if="!post.solPosCapacitacion" class="bi bi-camera-reels"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecCapEjec.slice(0, 4) == 1900">--</td>

                      <td v-else>{{ post.solFecCapEjec.slice(0, 10) }}</td>

                       <td>
                        <button @click="editContrato(post.idSolxPostulante)" :class="{
                          'btn btn-warning py-1 my-0': !post.solPosContratos,
                          'btn btn-success py-1 my-0': post.solPosContratos,
                        }">
                          <i v-if="post.solPosContratos" class="bi bi-check-circle"></i>
                          <i v-if="!post.solPosContratos" class="bi bi-vector-pen"></i>
                        </button>
                      </td>

                      <td v-if="post.solFecConEjec.slice(0, 4) == 1900">--</td>
                      <td v-if="post.solFecConEjec.slice(0, 4) != 1900">
                        {{ post.solFecConEjec.slice(0, 10) }}
                      </td>
                      
                      <td class="d-flex">
                        <b-button v-b-modal.modal-center5 @click="
                          () => {
                            idPostulante = post.idSolxPostulante;
                            solPosMotivo = post.solPosMotivo;
                            comentario = post.solComentario;
                            CargaObservaciones();
                          }
                        " :class="{
                          'btn btn-light border border-1':
                            post.solComentario == '',
                          'btn btn-danger': post.solComentario != '',
                        }">
                          <i class="bi bi-chat-dots"></i>
                        </b-button>

                        <button @click="
                          CrearUser(
                            post.idMaePostulante,
                            post.nombre.slice(21, post.nombre.length),
                            post.posNroDocumento,
                            post.idSolxPostulante
                          )
                          " :disabled="permisoVisualizador == 2 ||
                            permisoVisualizador == 18
                            ? false
                            : true
                            " class="btn btn-light border border-1 py-1 my-0 ms-2">
                          <i class="bi bi-person-add"></i>
                        </button>

                        <!-- <button
                          class="btn btn-success ms-2 py-1 my-0"
                          @click="
                            mandarComentarios(
                              post.idSolxPostulante,
                              post.solPosMotivo,
                              post.solComentario
                            )
                          "
                        >
                          <i class="bi bi-floppy"></i>
                        </button> -->
                        <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" class="btn btn-light ms-2 border border-1 py-1 my-0"
                          @click="mandarEstadoPostulanteXcorreo(post)">
                          <i class="bi bi-envelope-at"></i>
                        </button>

                        <!-- <button class="btn btn-success ms-2 border border-1 py-1 my-0"
                          @click="mandarEstadoPostulanteXcorreo(post)">
                          <i class="bi bi-envelope-at"></i>
                        </button> -->
                      </td>

                      <td v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        <input type="date" class="form-control" aria-describedby="emailHelp"
                          v-model="post.fecIniContrato" @change="datosIni(post)" />
                      </td>

                      <td v-if="permisoVisualizador == 6 || permisoVisualizador == 2 || permisoVisualizador == 18">
                        <input type="date" class="form-control" aria-describedby="emailHelp"
                          v-model="post.fecFinContrato" @change="datosFin(post)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <b-modal size="lg" id="modal-center5" centered title="COMENTARIOS" body-class="custom-modal-body"
                hide-footer>
                <div class="d-flex w-100 h mt-2">
                  <b-form-textarea v-if="permisoVisualizador == 10 || permisoVisualizador == 2" class="pt-4 my-0"
                    v-model="insertarComentario"></b-form-textarea>

                  <b-form-textarea v-else class="my-0 py-1" disabled v-model="comentario">
                  </b-form-textarea>

                  <button v-if="permisoVisualizador == 10 || permisoVisualizador == 2"
                    class="btn btn-success my-auto ms-2" @click="
                      mandarComentarios(
                        idPostulante,
                        solPosMotivo,
                        insertarComentario
                      )
                      ">
                    <i class="bi bi-floppy"></i>
                  </button>
                </div>

                <div class="mt-2">
                  <strong>Comentarios anteriores</strong>
                </div>
                <div class="d-flex w-100 mt-2">
                  <b-form-textarea class="pt-4" disabled rows="10" :value="observaciones
                    .map((o) => `${o.fecEstado} -- ${o.obsComentario}`)
                    .join('\n')
                    "></b-form-textarea>
                </div>
              </b-modal>

              <div v-if="
                dni_busqueda.length === 2 || dni_busqueda.length === 1
                  ? true
                  : false
              " class="text-center container overflow-hidden mt-5">
                <b-spinner variant="primary"></b-spinner>
                buscado .......
              </div>
            </div>

            <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
              <!-- Primera página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>

              <!-- Retroceder -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>

              <!-- Página actual -->
              <span class="pagination-info fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>

              <!-- Avanzar -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>

              <!-- Última página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  name: "SolimanologGestionDeSolicitudes",
  data() {
    return {
      idPostulante: "",
      solPosMotivo: "",
      comentario: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Solicitud/",
      url2:"https://apitopas.gruposolimano.com.pe/Documentos/SST/",
      amigo: "",
      prender: false,
      negado: true,
      negado2: true,
      cerrarPostulante: false,
      IdSolicitud: "",
      FecRegistro: "",
      FecFinEstimada: "",
      FecPresentacion: "",
      NomPuesto: "",
      CanPostulante: "",
      NomEmpresa: "",
      CentroCosto: "",
      SubCentroCosto: "",
      SubSubCentroCosto: "",
      DesDepartamento: "",
      DesProvincia: "",
      DesDistrito: "",
      nomSelAsignado: "",
      NomTrabajador: "",
      CargoBoleta: "",
      DesMotivo: "",
      DesExtra: "",
      DetalleMotivo: "",
      desSolEstado: "",
      LugarTrabajo: "",
      HorTrabajo: "",
      DesTipContrato: "",
      DiasDescanso: "",
      SueldoMensual: "",
      SueldoDiario: "",
      MonVariable: "",
      MonAlimientacion: "",
      MonMovilidad: "",
      HoraExtra: "",
      MonViatico: "",
      MonOtro: "",
      DesOpoPago: "",
      IndVacuna: "",
      IndCarnet: "",
      IndVulnerabilidad: "",
      IndEmpo: "",
      IndCovid: "",
      Adjunto: "",
      indJudiciales: Boolean,
      indPoliciales: Boolean,
      indPenales: Boolean,
      indSanidad: Boolean,
      indCertijoven: Boolean,
      rutaPerfil: '',
      ocultar: true,
      rutaDocumento: "",
     

      //otra api
      info: [],
      postulantes: [],
      campaña: "",
      //tercera api
      responsable: [],
      botonCambioRq: true,

      mandarPut: {
        idSolicitud: "",
        idSelAsignado: "",
      },

      codSolEstado: "",
      nombreDelUsuario: "",
      permisoVisualizador: null,

      // tablaAbajo
      currentPage: 1,
      itemsPerPage: 4,

      form: {
        solComentario: "",
      },

      idSelAsignado: "",
      idTrabajador: "",
      correoUno: "",
      correoDos: "",

      codigoUser: "",
      posNroDocumento: "",

      comentarioCorrela: "",
      forms: {
        IdSolxPostulante: "",
        FecIniContratos: "",
        FecFinContratos: "",
        idUsuario: "",
      },

      informacion: [],
      dni_busqueda: "",
      comentarios: [],
      acomodar: "",
      acomodare: "",
      retro: false,
      cerrar: true,
      cerrar2: true,
      cerrarTable1: true,
      cerrarTable2: false,
      Tabla1: true,
      adams: false,
      avanzar: true,

      observaciones: [],
      insertarComentario: "",
      referido: [],
      codigoCentro: "",
      idEmpresaRq: "",
      solDisViaje: false,
      solMovPropio: false,
      solAplicativo: false,
      solEpps: false,
      solUniforme: false,
      solMovil: false,
      solLaptop: false,
      fileName: '',
      selectedFile: null
    };
  },

  computed: {
    ...mapGetters("users", [
      "Items",
      "Permisos",
      "Contratos",
      "Tecnologia",
      "Operaciones",
      "Sst",
    ]),

    comentariosFiltrados() {
      // Filtra los comentarios basados en algún criterio
      // En este ejemplo, excluiremos los elementos con parCorrelativo "elemento_no_deseado"
      return this.comentarios
        .slice(5, this.comentarios.length - 1)
        .filter((coment) => coment.parCorrelativo !== "031");
    },
    filteredInfo() {
      if (this.dni_busqueda.length < 3) return this.informacion;

      return this.informacion.filter(post =>
        post.nombre.toLowerCase().includes(this.dni_busqueda.toLowerCase())
      );
    },

    totalPages() {
      return Math.ceil(this.filteredInfo.length / this.itemsPerPage);
    },

    paginatedInfo() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredInfo.slice(start, start + this.itemsPerPage);
    },
  },

  async mounted() {
    this.parametro = this.$route.params.ide;
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.forms.idUsuario = localStorage.getItem("userId");

    const api3 = this.axios.get("JerarquiaTrabajadorData/Jerarquia/4");
    let r = await api3;
    this.responsable = r.data;
    console.log(r.data);

    const api2 = this.axios.get("ParametroData/Parametro/59");
    let res = await api2;
    this.info = res.data;

    this.axios.get("ParametroData/Parametro/7729").then((r) => {
      this.referido = r.data;
    });

    this.mandarPut.idSolicitud = this.$route.params.ide;

    const respuesta = await this.axios.get(
      "SolicitudPostulante/Obtener/" + this.parametro
    );
    this.postulantes = respuesta.data;
    console.log('errross',this.postulantes)
    this.botonCambioRq = this.postulantes.some(
      (objeto) => objeto.solPosMotivo == "010"
    )
      ? true
      : false;

    const api = this.axios.get(
      "SolicitudData/Obtener/" + this.mandarPut.idSolicitud
    );
    let response = await api;
    console.log("api", response);

    this.prender = true;
    const RqUsuario = response.data[0].idEmpresa;
    localStorage.setItem("RqEmpresa", RqUsuario);
    this.IdSolicitud = response.data[0].idSolicitud;
    this.FecRegistro = response.data[0].fecRegistro;
    this.FecFinEstimada = response.data[0].fecSolFinal;
    this.FecPresentacion = response.data[0].fecPresentacion;
    this.NomPuesto = response.data[0].nomPuesto;
    this.CanPostulante = response.data[0].canPostulante;
    this.NomEmpresa = response.data[0].nomEmpresa;
    this.CentroCosto = response.data[0].centroCosto;
    this.SubCentroCosto = response.data[0].subCentroCosto;
    this.SubSubCentroCosto = response.data[0].subSubCentroCosto;
    this.DesDepartamento = response.data[0].desDepartamento;
    this.DesProvincia = response.data[0].desProvincia;
    this.DesDistrito = response.data[0].desDistrito;
    this.NomTrabajador = response.data[0].nomTrabajador;
    this.CargoBoleta = response.data[0].cargoBoleta;
    this.DesMotivo = response.data[0].desMotivo;
    this.DesExtra = response.data[0].desExtra;
    this.DetalleMotivo = response.data[0].detalleMotivo;
    this.LugarTrabajo = response.data[0].lugarTrabajo;
    this.HorTrabajo = response.data[0].horTrabajo;
    this.DesTipContrato = response.data[0].desTipContrato;
    this.DiasDescanso = response.data[0].diasDescanso;
    this.SueldoMensual = response.data[0].sueldoMensual;
    this.SueldoDiario = response.data[0].sueldoDiario;
    this.MonVariable = response.data[0].monVariable;
    this.MonAlimientacion = response.data[0].monAlimentacion;
    this.MonMovilidad = response.data[0].monMovilidad;
    this.HoraExtra = response.data[0].horaExtra;
    this.MonViatico = response.data[0].monViatico;
    this.MonOtro = response.data[0].monOtro;
    this.DesOpoPago = response.data[0].desOpoPago;
    this.desSolEstado = response.data[0].desSolEstado;
    this.nomSelAsignado = response.data[0].nomSelAsignado;

    this.IndVacuna = response.data[0].indVacuna;
    this.IndCarnet = response.data[0].indCarnet;
    this.indJudiciales = response.data[0].indJudiciales;
    this.indPoliciales = response.data[0].indPoliciales;
    this.indPenales = response.data[0].indPenales;
    this.indSanidad = response.data[0].indSanidad;
    this.indCertijoven = response.data[0].indCertiJoven;

    this.campaña = response.data[0].campana;

    this.IndVulnerabilidad = response.data[0].indVulnerabilidad;
    this.IndEmpo = response.data[0].indEmpo;
    this.IndCovid = response.data[0].indCovid;
    this.Adjunto = response.data[0].adjunto;

    this.codigoCentro = response.data[0].codCentro

    this.idEmpresaRq = response.data[0].idEmpresa
    this.solDisViaje = response.data[0].solDisviaje
    this.solMovPropio = response.data[0].solMovpropio
    this.solAplicativo = response.data[0].solAplicativo
    this.solEpps = response.data[0].usoSolEPPs
    this.solUniforme = response.data[0].usoSolUniforme
    this.solMovil = response.data[0].usoSolMovilCoporativo
    this.solLaptop = response.data[0].usoSolLaptop
    this.rutaPerfil = response.data[0].rutaPerfil

    //segunda api
    console.log("informacion", response)
    let date1 = new Date("2020-10-23");
    console.log(date1.toISOString().slice(0, 10));
    this.axios
      .get("SolicitudData/Obtener/" + this.$route.params.ide)
      .then((r) => {
        console.log(r.data);
        this.idSelAsignado = r.data[0].idSelAsignado;
        this.idTrabajador = r.data[0].idTrabajador;
        this.ObtenerCorreos(this.idSelAsignado, this.idTrabajador);
      });

    let responses = await this.axios.get(
      "SolicitudPostulante/Obtener/" + this.parametro
    );
    console.log(responses.data);
    this.informacion = responses.data;
    console.log('La informacion',this.informacion);

    for (let index of this.informacion) {
      if (
        index.solPosSeleccion == true &&
        index.solPosEntrevista == true &&
        index.solPosDocumento == true &&
        index.solPosContratos == true &&
        index.solPosCapacitacion == true &&
        index.solNotContrato == false &&
        index.fecIniContrato > "2023-02-09"
      ) {
        console.log(index);
        this.axios
          .post(
            `Values/CorreoProcesoSel?correoUsuario=${this.correoUno
            }&correoUsuario2=${this.correoDos}&Nombre=${index.nombre.slice(
              9,
              index.nombre.length
            )}&FechaInicio=${index.fecIniContrato}&idSolicitud=${this.$route.params.ide
            }&apePaterno=${index.nombre.slice(9, index.nombre.length)}`
          )
          .then((r) => {
            console.log(r.data);
            if (r.data == true) {
              this.ModificarEstadoContra(index.idSolxPostulante);
            }
          });
      }
    }

    let comentario = await this.axios.get("ParametroData/Parametro/7507");
    this.comentarios = comentario.data;
    console.log(this.comentarios);
  },

  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {
    ...mapActions("solicitudesListado", ["getAttributs"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

 

  handleFileUpload(event, post, index) {
    const file = event.target.files[0];
    console.log(file, index, 'cantidad', post)
    if (file) {
      // 1. Guardamos el nombre en el objeto de la fila para que se vea el "Listo"
      this.$set(post, 'fileName', file.name);
      
      // 2. Aquí ejecutas tu lógica de envío al servidor (tu método mandarPdfServicios)
      this.mandarPdfServicios(
        file, // enviamos el archivo real
        post.idMaePostulante,
        post.idSolxPostulante
      );
    }
  },

  async mandarPdfServicios(archivo, idPostulante,idSolxPostulante) {
  
  try {
    // 1. Creamos el FormData
    let formData = new FormData();
    
    // 2. Agregamos SOLO lo que pide tu [FromForm] en el Backend
    // IMPORTANTE: Los nombres "archivo" e "idTrabajador" deben ser iguales a los del C#
    formData.append("archivo", archivo);         
    formData.append("idPostulante", idPostulante);
    formData.append("idsolxPostulante", idSolxPostulante);
    formData.append("idUsuario", localStorage.getItem("userId"));

    // 3. Enviamos a la ruta específica que me mostraste
    const response = await this.axios.put("SolicitudData/SubirConFromForm", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log("Respuesta del servidor:", response.data);

    if (response.data.success) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: `Archivo de ${archivo.name} subido correctamente!`,
        showConfirmButton: false,
        timer: 1500,
      });
      this.getAttributes(); // refrescamos la información para mostrar el nuevo archivo
    }

  } catch (error) {
    console.error("Error en el servidor:", error);
    this.$toast?.error("No se pudo subir el archivo");
  }
},

    async getAttributes() {
      let parametro = this.$route.params.ide;

      let response = await this.axios.get(
        "SolicitudPostulante/Obtener/" + parametro
      );

      this.informacion = response.data;

      this.botonCambioRq = this.informacion.some(
        (objeto) => objeto.solPosMotivo == "010"
      )
        ? true
        : false;
    },

    CargaObservaciones() {
      this.axios
        .get(`SolicitudPostulante/ObtenerPosxSolEstado/${this.idPostulante}`)
        .then((r) => {
          this.observaciones = r.data;
        });
    },
    ModificarEstadoContra(idSolxPostulante) {
      let solNotContrato = true;

      this.axios.put(`SolicitudPostulante/ModificarCorreoContrato`, {
        idSolxPostulante,
        solNotContrato,
      });
    },

    ObtenerCorreos(correo1, correo2) {
      console.log(correo2);
      this.axios.get(`Values/Obtener/${correo1}`).then((r) => {
        console.log(r.data[0].correo);
        this.correoUno = r.data[0].correo;
      });

      this.axios.get(`Values/Obtener/${correo2}`).then((r) => {
        console.log(r.data[0].correo);
        this.correoDos = r.data[0].correo;
      });
    },

    cambiarReferido(idSolxPostulante, codSolFuente) {
      this.axios
        .put("SolicitudPostulante/ModificarSolReferido", {
          idSolxPostulante,
          codSolFuente,
        })
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "¡Se Realizó los Cambios!",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          this.getAttributes();
        });
    },

    mandarEstadoPostulanteXcorreo(items) {
      this.getAttributes();
      console.log(this.correoUno, this.correoDos);
      console.log(items);
      this.axios
        .post(
          `Values/CorreoPos?correoUsuario=${this.correoUno}&correoUsuario2=${this.correoDos
          }&estadoPostulante=${items.solDesMotivo
          }&NombrePos=${items.nombre.slice(9, items.nombre.length)}`
        )
        .then((r) => {
          console.log(r.data);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "¡Se Realizó los Cambios!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    mandarCorreo(usuCodigo, usuCorreo, nombre, postulante) {
      console.log(
        usuCodigo,
        usuCorreo,
        this.numeroDocumento,
        nombre,
        postulante
      );

      let parametro = this.$route.params.ide;

      this.axios.get("SolicitudPostulante/Obtener/" + parametro).then((r) => {
        this.informacion = r.data;
        console.log(r.data);
        for (let index of this.informacion) {
          if (index.idSolxPostulante == postulante) {
            this.axios
              .post(
                `Values/CorreoPostulante?correoUsuario=${index.posCorreo
                }&usuCodigo=${index.nombre.slice(0, 8)}&Contrase%C3%B1a=${this.numeroDocumento
                }&Nombre=${index.nombre.slice(8, index.nombre.length)}&Puesto=${this.NomPuesto
                }`
              )
              .then((r) => {
                console.log(r.data);
              });
          }
        }
      });
    },

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      this.dni_busqueda.length < 3 ? (this.adams = false) : (this.adams = true);

      return (
        items.nombre
          .toLocaleLowerCase()
          .indexOf(this.dni_busqueda.toLocaleLowerCase()) >= 0
      );
    },

    async CrearUser(postulante, codigo, numeroDocumento, idSolxPostulante) {
      this.acomodar = postulante;
      this.codigoUser = codigo;
      this.numeroDocumento = numeroDocumento;
      let idPostulante = postulante;

      const user = {
        idPostulante,
      };
      this.axios.post("UsuarioPostulante/Registrar", user).then((respuesta) => {
        console.log(respuesta.data);
        if (respuesta.data == true) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "¡Se envio correo con usuario y contraseña!",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getAttributes();
          console.log('informacion', this.informacion);
          for (let index of this.informacion) {
            if (index.idSolxPostulante == idSolxPostulante) {
              console.log("llegue aqui", index.nombre.slice(1, 8),
                index.posCorreo,
                index.nombre.slice(9, index.nombre.length),
                idSolxPostulante);

              this.mandarCorreo(
                index.nombre.slice(1, 8),
                index.posCorreo,
                index.nombre.slice(9, index.nombre.length),
                idSolxPostulante
              );
            }
          }
        }
      });
    },

    mandarComentarios(idSolxPostulante, solPosMotivos, solComentario) {
      console.log(idSolxPostulante, solPosMotivos, solComentario);

      if (this.comentarioCorrela.length != "") {
        let solPosMotivo = this.comentarioCorrela;
        let idUsuario = this.forms.idUsuario;
        const form = {
          idSolxPostulante,
          solPosMotivo,
          solComentario,
          idUsuario,
        };

        this.axios
          .put("SolicitudPostulante/ModificarSolxPosEstado", form)
          .then((r) => {
            console.log(r.data);
            if (r.data == true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡Se Realizó los Cambios!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.insertarComentario = "";
              this.getAttributes();
              this.CargaObservaciones();
            }
          });
        console.log("se aplico el prier if");
      } else {
        let solPosMotivo = solPosMotivos;
        let idUsuario = this.forms.idUsuario;
        const form = {
          idSolxPostulante,
          solPosMotivo,
          solComentario,
          idUsuario,
        };

        console.log("se aplico el segundo if", form);

        this.axios
          .put("SolicitudPostulante/ModificarSolxPosEstado", form)
          .then((r) => {
            if (r.data == true) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "¡Se Realizó los Cambios!",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.insertarComentario = "";
            this.getAttributes();
            this.CargaObservaciones();
          });
      }
    },
    datosIni(post) {
      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: post.fecIniContrato,
        fecFinContratos: "1900-01-01",
      };

      this.axios
        .put("SolicitudPostulante/ModificarFecContrato", from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "¡Cambio de fecha Inicio Realizado!",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        });
    },

    datosFin(post) {
      const from = {
        idSolxPostulante: post.idSolxPostulante,
        idUsuario: this.forms.idUsuario,
        fecIniContratos: "1900-01-01",
        fecFinContratos: post.fecFinContrato,
      };

      this.axios
        .put("SolicitudPostulante/ModificarFecContrato", from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "¡Cambio de fecha fin Realizado!",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        });
    },

    comenta(event, idSolxPostulante, solPosMotivos, solComentario) {
      console.log(event.target.value);
      this.comentarioCorrela = event.target.value;
      this.mandarComentarios(idSolxPostulante, solPosMotivos, solComentario);
    },
    editSeleccion(id) {
      this.$router.push("/EditadoSeleccion/" + id);
      this.axios.get("TrabSeleccion/ValidarEtapaSeleccion?idSolXpostulante=" + id).then(r =>{
        console.log(r.data);       
      })
      window.scroll(0, 0);
    },

    editEntrevista(id) {
      this.$router.push("/datosEntrevista/" + id);
      window.scroll(0, 0);
    },
    editDocumentos(id) {
      this.$router.push("/datosDocmuentos/" + id);
      window.scroll(0, 0);
    },
    editCapacitaciones(id) {
      this.$router.push("/datosCapacitaciones/" + id);
      window.scroll(0, 0);
    },

    editContrato(id) {
      this.$router.push("/selectContrato/" + id);
      window.scroll(0, 0);
    },



    ModificarTrabajador(event) {
      this.mandarPut.idSelAsignado = event.target.value;
      this.negado2 = false;
      for (let i of this.responsable) {
        if (i.idTrabajador == event.target.value) {
          this.nombreDelUsuario = i.nombreTrabajador;
        }
      }
    },

    getAttributesPut() {
      console.log(this.mandarPut);
      this.axios
        .put("TrabSeleccion/ModificarTrabSeleccion", this.mandarPut)
        .then((r) => {
          console.log(r.data);
          if (r.data == true) {
            this.getAttributs();
            Swal.fire({
              icon: "success",
              title: `El responsable asignado es  ${this.nombreDelUsuario}`,
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
    },

    ModificarEstado(event) {
      this.cancelacion = false;
      this.codSolEstado = event.target.value;
      console.log(this.codSolEstado);
      this.negado = false;

      //solo el recahzo el 4
      //combito de chebox marcados nomas apreces
    },

    getAttributesEstado() {
      let idSolicitud = this.mandarPut.idSolicitud;
      let codSolEstado = this.codSolEstado;
      let idUsuario = localStorage.getItem('userId')
      let json = {
        idSolicitud,
        codSolEstado,
        idUsuario
      };
      this.axios.put("TrabSeleccion/ModificarEstadoSol", json).then((r) => {
        if (r.data == true) {
          this.getAttributs();
          Swal.fire({
            icon: "error",
            title: "Se rechazó el RQ",
            showConfirmButton: false,
            timer: 1800,
          });
        }
      });
    },

    editarDatoSolicitud() {
      this.$router.push("/datosSolicitud/" + this.$route.params.ide);
      window.scroll(0, 0);
    },

    base() {
      // console.log(this.parametro)
      this.$router.push("/registroGestionSolicitud/" + this.parametro);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 1.2rem;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamaño {
  font-size: 0.65rem;
}

input {
  font-size: 0.65rem;
}

.tabla {
  background: rgb(24, 147, 196);
}

.bg-solimano {
  background: #0080c8;
}

.agrandar {
  width: 280px;
  /* height: 10px; */
}

.referido {
  width: 150px;
}

.tamañoLetra {
  font-family: sans-serif;
  font-size: 0.65rem;
}

.pintar {
  font-weight: 700;
  color: #002c5d;
}

.tamañoCuadro {
  font-size: 0.65rem;
}

.letrasTitulos {
  color: #52658c;
}

.selector {
  width: 500px;
}

#modal-center5 .modal-dialog {
  min-height: 300px;
  /* Ajusta el valor según tus necesidades */
}

.btn-solimano {
  background: #0080c8;
}



.cursor-pointer {
  cursor: pointer;
}



</style>
